import {Alert} from '@chakra-ui/react'
import {formatDateKey, multipleDigitsNumberFormatter} from '@cypro/ui/utils'
import {useTranslate} from '@tolgee/react'

export interface DisplayedDose {
  id: string
  therapyDate: number | null
  totalAmount: number | null
  activeSubstance?: {name?: string | null; activeSubstanceDetails?: {doseUnit?: {displayName?: string | null} | null} | null} | null
}

export function formatDose(dose: DisplayedDose, amount: number | null) {
  const unit = dose.activeSubstance?.activeSubstanceDetails?.doseUnit?.displayName ?? ''
  return `${amount === null ? '-' : multipleDigitsNumberFormatter.format(amount)} ${unit}`.trim()
}

/** Future validated prescriptions that keep their dose after a weight, height or GFR change, to be checked manually (CY-379). */
export function KeptDosesAlert({title, doses}: {title: string; doses: DisplayedDose[]}) {
  const {t} = useTranslate('common')

  if (!doses.length) return null

  return (
    <Alert.Root status="warning">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Title>{title}</Alert.Title>
        {doses.map(dose => (
          <Alert.Description key={dose.id}>
            {dose.therapyDate ? formatDateKey(dose.therapyDate) : '-'}: {dose.activeSubstance?.name ?? '-'}{' '}
            {formatDose(dose, dose.totalAmount)}
          </Alert.Description>
        ))}
        <Alert.Description>{t('dose_change.check_manually', 'Check these prescriptions manually.')}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  )
}
